import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const UserInfo = ({
    balance,
    currencySign,
    showBalance,
    hasDetails,
    toggleBalanceVisibility,
    selectedBookmakerFeed,
}) => {
    const balanceValue = balance !== null
        ? `${currencySign}${balance.toFixed(2)}`
        : 'N/A'

    // This is generic error handling i.e. we got a bad response from the userInfo endpoint
    if (!hasDetails) {
        return (
            <span className="bs-userInfo__info">
                <span>
                    <span className="bs-userInfo__infoLine">Balance</span>
                    <span className="bs-userInfo__balance">N/A</span>
                </span>
            </span>
        )
    }

    return (
        <span
            className="bs-userInfo__info"
            tabIndex={0}
            role="button"
            onClick={() => {
                toggleBalanceVisibility(selectedBookmakerFeed)
            }}
        >
            {showBalance ? (
                <span>
                    <span className="bs-userInfo__infoLine">Balance</span>
                    <span className="bs-userInfo__balance">{balanceValue}</span>
                </span>
            ) : (
                <span className="bs-userInfo__balance">Show Balance</span>
            )}
        </span>
    )
};

UserInfo.defaultProps = {
    hasDetails: false,
    showBalance: true,
    balance: null,
};

UserInfo.propTypes = {
    hasDetails: PropTypes.bool,
    balance: PropTypes.number,
    currencySign: PropTypes.string.isRequired,
    showBalance: PropTypes.bool,
    toggleBalanceVisibility: PropTypes.func.isRequired,
    selectedBookmakerFeed: PropTypes.string.isRequired,
};

export default UserInfo;



// WEBPACK FOOTER //
// /src/js/common/userInfo/UserInfo.jsx